<template>
  <div class="cw-flex cw-flex-wrap">
    <!-- Filter input -->
    <div class="cw-flex cw-flex-col cw-w-full cw-mb-3">
      <label for="locations-filter-input"
        class="cw-font-semibold cw-text-sm">{{ $t('enabled-locations-map.search') }}</label>
      <input id="locations-filter-input"
        v-model="filterText"
        class="cw-block cw-appearance-none cw-w-full cw-py-1 cw-px-2 cw-mb-1 cw-text-base cw-leading-normal cw-bg-white cw-text-gray-800 cw-border cw-border-gray-200 cw-rounded"
        aria-describedby="locations-filter-description">
      <p id="locations-filter-description"
        class="cw-text-xs cw-text-slate-700">
        {{ $t('enabled-locations-map.filter') }}
      </p>
    </div>

    <!-- Location Type -->
    <fieldset class="cw-w-full cw-pt-3 cw-pb-2 cw-flex cw-gap-x-4 cw-gap-y-2 cw-flex-wrap cw-text-sm">
      <legend class="cw-font-semibold cw-text-sm">
        {{ $t('enabled-locations-map.location-filter') }}
      </legend>

      <!-- All locations -->
      <label class="cw-flex cw-items-center cw-flex-row cw-gap-1">
        <input v-model="filterOptions"
          type="checkbox"
          name="location-type"
          value="enabledLocations">
        {{ $t('enabled-locations-map.enabled-location') }}
      </label>
      <!-- Local IX locations -->
      <label class="cw-flex cw-items-center cw-flex-row cw-gap-1">
        <input v-model="filterOptions"
          type="checkbox"
          name="location-type"
          value="localIxLocations">
        {{ $t('enabled-locations-map.local-ix-available') }}
      </label>
      <!-- 100G enabled locations -->
      <label class="cw-flex cw-items-center cw-flex-row cw-gap-1">
        <input v-model="filterOptions"
          type="checkbox"
          name="location-type"
          value="100GLocations">
        {{ $t('enabled-locations-map.100G-enabled') }}
      </label>
      <!-- MCR enabled locations -->
      <label class="cw-flex cw-items-center cw-flex-row cw-gap-1">
        <input v-model="filterOptions"
          type="checkbox"
          name="location-type"
          value="mcrLocations">
        {{ $t('enabled-locations-map.mcr-enabled') }}
      </label>
      <!-- MVE Enabled locations -->
      <label class="cw-flex cw-items-center cw-flex-row cw-gap-1">
        <input v-model="filterOptions"
          type="checkbox"
          name="location-type"
          value="mveLocations">
        {{ $t('enabled-locations-map.mve-enabled') }}
      </label>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'LocationsFilter',

  props: {
    filterTextValue: {
      type: String,
      required: true,
    },
    filterOptionsValue: {
      type: Array,
      required: true,
    },
  },

  computed: {
    filterText: {
      get() {
        return this.filterTextValue
      },
      set(value) {
        this.$emit('updateFilter', {
          key: 'filterTextValue',
          value: value.trim(),
        })
      },
    },
    filterOptions: {
      get() {
        return this.filterOptionsValue
      },
      set(value) {
        this.$emit('updateFilter', {
          key: 'filterOptionsValue',
          value,
        })
      },
    },
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('search')) {
      this.filterText = urlParams.get('search')
    }
    if (urlParams.has('type')) {
      this.filterOptions = urlParams.getAll('type')
    }
  },
}
</script>
